import React, { useCallback } from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { useIsMobileScreen } from '~/hooks'
import { AppleIcon, PlaystoreIcon } from '~/assets/icons'

enum AppType {
  GOOGLE_PLAY = 'googlePlay',
  APP_STORE = 'appStore'
}

export const AppStoreButtons = () => {
  const isMobile = useIsMobileScreen()
  const onStoreClick = useCallback((app: AppType) => {
    const url = app === AppType.GOOGLE_PLAY
      ? 'https://play.google.com/store/apps/details?id=com.mutual.app'
      : 'https://apps.apple.com/br/app/mutual/id1317635006?l=en'

    window.open(url)
  }, [])

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: `${isMobile ? 'column' : 'row'}`,
      gap: 1
    }}>
      <Button
        onClick={() => onStoreClick(AppType.GOOGLE_PLAY)}
        sx={{
          width: `${isMobile ? '100%' : '144px'}`,
          backgroundColor: '#2B2B2B',
          height: 40,
          color: '#FFF',
          borderRadius: 0.5,
          transition: 'filter 0.2s',
          gap: 1,
          '&:hover': {
            background: '#2B2B2B',
            filter: 'brightness(90%)'
          }
        }}
      >
        <Typography variant='airbnbBody2' sx={{ fontWeight: 'bold' }}>Google Play</Typography>
        <PlaystoreIcon />
      </Button>

      <Button
        onClick={() => onStoreClick(AppType.APP_STORE)}
        sx={{
          width: `${isMobile ? '100%' : '144px'}`,
          backgroundColor: '#2B2B2B',
          height: 40,
          color: '#FFF',
          borderRadius: 0.5,
          gap: 1,
          transition: 'filter 0.2s',
          '&:hover': {
            background: '#2B2B2B',
            filter: 'brightness(90%)'
          }
        }}
      >
        <Typography variant='airbnbBody2' sx={{ fontWeight: 'bold' }}>App Store</Typography>
        <AppleIcon />
      </Button>
    </Box>
  )
}
